(() => {
  const refineSendWillPopup = () => {
    document.querySelectorAll('.pp-modal .ecomsend__Modal__Content').forEach((modal) => {
      if (modal.dataset.acyrosPopupRefined === 'true') return;

      const title = modal.querySelector('.ecomsend__Modal__TitleText');
      const lead = modal.querySelector('.ecomsend__Modal__TitleHelpText');
      const detail = modal.querySelector('.ecomsend__Modal__DescriptionText');
      const button = modal.querySelector('.ecomsend__Button');

      if (!title && !lead && !detail && !button) return;
      modal.dataset.acyrosPopupRefined = 'true';

      if (title) title.textContent = 'Danke für deinen Start.';
      if (lead) lead.textContent = 'Zum Release schenken wir dir 10 € auf deine erste Bestellung.';
      if (detail) detail.textContent = 'Deinen Rabatt kannst du direkt beim Checkout einlösen.';
      if (button) button.textContent = '10 € sichern';
    });
  };

  const observe = () => {
    refineSendWillPopup();
    new MutationObserver(refineSendWillPopup).observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe, { once: true });
  else observe();
})();
